const dateInput = {
  icon: {
    size: '24px',
    color: 'primary',
    background: 'primary',
    opacity: 0,
  },
};
export default dateInput;
